export const hasMinLength = (len, x) => x != null && x.length >= len;
